function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "38",
  height: "38",
  viewBox: "0 0 38 38",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_d_3_5)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: "19",
  cy: "15.001",
  r: "13",
  fill: "#39C360"
}), /*#__PURE__*/React.createElement("circle", {
  cx: "19",
  cy: "15.001",
  r: "14",
  stroke: "#fff",
  strokeWidth: "2"
})), /*#__PURE__*/React.createElement("path", {
  d: "M11.56 18.355h3.18l3.74 2.558c.373.235.854-.06.854-.53V9.623c0-.53-.534-.794-.881-.5l-3.713 2.499h-3.18c-.32 0-.56.294-.56.617v5.528c0 .323.24.588.56.588zm9.99-1.147c-.293 0-.56.265-.56.617 0 .324.267.588.56.588.856 0 1.657-.382 2.218-1a3.58 3.58 0 00.908-2.41 3.58 3.58 0 00-.908-2.411 2.936 2.936 0 00-2.217-1.03c-.294 0-.561.295-.561.618 0 .353.267.618.56.618.562 0 1.07.235 1.417.646.373.383.587.941.587 1.559 0 .617-.213 1.146-.587 1.558a1.932 1.932 0 01-1.416.647zm0 2.558c-.293 0-.56.294-.56.617 0 .353.267.618.56.618 1.523 0 2.886-.677 3.874-1.764A6.407 6.407 0 0027 15.003a6.407 6.407 0 00-1.576-4.234c-.988-1.088-2.35-1.764-3.873-1.764-.294 0-.561.265-.561.617 0 .324.267.588.56.588 1.203 0 2.298.559 3.073 1.412.801.852 1.282 2.058 1.282 3.38 0 1.324-.481 2.5-1.282 3.382a4.147 4.147 0 01-3.072 1.382z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_d_3_5",
  x: "0",
  y: ".001",
  width: "38",
  height: "38",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "4"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "2"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_3_5"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_3_5",
  result: "shape"
})))));